function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const Sentry = require("@sentry/nextjs");
const { getCachedData } = require("server/services/data-service/providers/base-data-provider");
const { PlatformManifestProvider } = require("server/services/data-service/providers/platform-manifest-provider");
export const getPlatformManifest = function() {
    var _ref = _async_to_generator(function*() {
        let platformManifest = {};
        try {
            const provider = new PlatformManifestProvider();
            platformManifest = yield getCachedData(provider);
        } catch (e) {
            Sentry.captureException(e);
            return {
                success: false
            };
        }
        return platformManifest;
    });
    return function getPlatformManifest() {
        return _ref.apply(this, arguments);
    };
}();
